import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg6, ROUTER_PATHS } from '@/shared';
import {
  CreateCountryParams,
  useCreateCountry,
  useUpdateCountry,
} from '@/shared/actions/erp/countries.actions';
import {
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { Country } from '@/shared/interfaces/erp/system-settings';
import { newCountrySchema } from '@/shared/utils';

export type SaveCountryProps = {
  editCountry?: Country;
  titlePage: string;
};

export type SaveFormData = CreateCountryParams & {};

const returnUrlCountries = ROUTER_PATHS.administration.paisesNav;

const SaveCountry: React.FC<SaveCountryProps> = ({
  titlePage,
  editCountry,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createCountryMutation = useCreateCountry(navigate, returnUrlCountries);
  const updateCountryMutation = useUpdateCountry(navigate, returnUrlCountries);

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newCountrySchema) as any,
    defaultValues: {
      estado: true,
      cobertura: false,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* effects
  useEffect(() => {
    if (!editCountry?.id_pais) return;
    setShrink(true);
    reset(editCountry);
  }, []);

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* edit
    if (editCountry?.id_pais) {
      updateCountryMutation.mutate({
        id: editCountry.id_pais,
        data: form.getValues(),
      });
      return;
    }

    ///* create
    return createCountryMutation.mutate(form.getValues());
  };

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlCountries);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ''}
        shrink={shrink}
      />

      <CustomTextField
        label="Código"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ''}
        error={errors.codigo}
        helperText={errors.codigo?.message ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled={!!editCountry?.id_pais}
      />
      <CustomTextField
        label="Nacionalidad"
        name="nacionalidad"
        control={form.control}
        defaultValue={form.getValues().nacionalidad || ''}
        error={errors.nacionalidad}
        helperText={errors.nacionalidad?.message ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
      />
      {/* <CustomTextField
        label="Numero de referencia"
        name="numero_referencia"
        control={form.control}
        defaultValue={form.getValues().numero_referencia || ''}
        error={errors.numero_referencia}
        helperText={errors.numero_referencia?.message ?? ''}
        shrink={shrink}
        required={false}
        size={gridSizeMdLg6}
      /> */}
      <SampleCheckbox
        label="Tiene cobertura"
        name="cobertura"
        control={form.control}
        defaultValue={!!form.getValues().cobertura}
        size={gridSizeMdLg6}
      />
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
        size={gridSizeMdLg6}
      />
    </SingleFormBoxScene>
  );
};

export default SaveCountry;
